
import React from 'react'
import List from '../List';
import SubPageListItem from '../SubPageListItem';

import styles from './SubPageList.module.css';

// The reader facing index of the pages under a section. The sidebar already links
// all of these, but it is a drawer on phones and pinned off to the right on
// desktop, so a top level page also spells out its own subpages under the
// content. Order is the parent's stored `subpages` array, never derived.
const SubPageList = props => {

  const { pagelist = [], navLevel = 0 } = props;

  if (pagelist.length === 0) return null;

  return (
    <List className={[styles.List, styles[`Level${navLevel}`]].join(' ')}>
      { pagelist.map( id => <SubPageListItem key={id} id={id} navLevel={navLevel + 1} /> ) }
    </List>
  )
}

export default SubPageList
